import React from 'react'
import ReorderIcon from '@mui/icons-material/Reorder';
const ReorderCol = () => {
  return <ReorderIcon/>
}

export default ReorderCol